import { render } from "./ZoomableImage.vue?vue&type=template&id=67029fb9&bindings={}"
import script from "./ZoomableImage.vue?vue&type=script&lang=ts"
export * from "./ZoomableImage.vue?vue&type=script&lang=ts"

import "./ZoomableImage.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script